import type { ComponentType, ExoticComponent } from 'react';
import type { RemoteConfig } from './types';

type AnyComponent = ComponentType | ExoticComponent;

const isValidComponent = (value: unknown): value is AnyComponent => {
  if (typeof value === 'function') return true;
  if (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { $$typeof?: unknown }).$$typeof === 'symbol'
  ) {
    return true;
  }
  return false;
};

export const extractComponent = (
  moduleExports: unknown,
  remoteName: string,
  exposedModule: string,
): AnyComponent => {
  const candidate =
    (moduleExports as { default?: unknown } | null | undefined)?.default ??
    moduleExports;

  if (!isValidComponent(candidate)) {
    throw new Error(
      `[MF] "${remoteName}/${exposedModule}" did not export a valid React component`,
    );
  }

  return candidate;
};

export const resolveRemoteOrigin = (remote: RemoteConfig): string => {
  if (!remote.entry) {
    throw new Error(`[MF] Remote "${remote.name}" is missing an entry URL`);
  }
  return new URL(remote.entry, globalThis.location?.origin).origin;
};
